module.exports = __webpack_public_path__ + "static/media/chat_notify.2529c259.mp3";